import $ from 'jquery';
import ModalBaseClass from '../../libs/modal/ModalBaseClass';

/**
 * ホテルプランモーダル
 */
export default class HotelPlanModalClass extends ModalBaseClass {
  constructor() {
    super('#modal_hotel_plan');
    this.name = 'HotelPlanModalClass';

    this.onClickOpenListener = this.onClickOpen.bind(this);
  }

  onCreate() {
    super.onCreate();
    $('.js-modal_hotel_plan').on('click', this.onClickOpenListener);
  }

  onClickOpen(e) {
    e.preventDefault();
    const _this = $(e.currentTarget);

    const id = _this.attr('data-target');

    $('.content', this.target).css({ display: '' });
    let contentTarget;
    if (id) {
      contentTarget = $('.content[data-id=' + id + ']', this.target);
    } else {
      contentTarget = $('.content', this.target).eq(0);
    }
    contentTarget.css({ display: 'block' });

    this.onOpen();
  }

  onOpenAfter() {
    super.onOpenAfter();
    $(window).trigger('resize');
  }
}
